// Pixel art Prince of Persia characters for the career timeline
export function PixelPrince({ className = "", fighting = false, slashing = false, entering = false, throwingKnife = false, knifeDirection = 'right' }) {
    if (entering) {
        return (
            <div className={`relative ${className} prince-entrance`} 
                 style={{ width: '32px', height: '40px', filter: 'drop-shadow(1px 1px 0 #000) drop-shadow(-1px -1px 0 #000)' }}>
                {/* BIG entrance bang effect - multiple layers */}
                <div className="absolute inset-0 entrance-bang-outer" style={{ 
                    background: 'radial-gradient(circle, rgba(234, 179, 8, 0.8) 0%, rgba(234, 179, 8, 0.4) 30%, transparent 70%)',
                    width: '120px',
                    height: '120px',
                    left: '-44px',
                    top: '-40px',
                    animation: 'bangPulse 0.6s ease-out'
                }} />
                <div className="absolute inset-0 entrance-bang" style={{ 
                    background: 'radial-gradient(circle, #FFFFFF 0%, #EAB308 30%, transparent 60%)',
                    width: '80px',
                    height: '80px',
                    left: '-24px',
                    top: '-20px',
                    animation: 'bangFlash 0.4s ease-out'
                }} />
                {/* Star burst effect */}
                <div className="absolute" style={{
                    width: '100px',
                    height: '100px',
                    left: '-34px',
                    top: '-30px',
                    background: 'conic-gradient(from 0deg, transparent, #EAB308 10%, transparent 20%, #EAB308 30%, transparent 40%, #EAB308 50%, transparent 60%, #EAB308 70%, transparent 80%, #EAB308 90%, transparent)',
                    animation: 'starBurst 0.8s ease-out',
                    opacity: 0.7
                }} />
                <svg viewBox="0 0 16 20" className="w-full h-full relative z-10" style={{ imageRendering: 'pixelated' }}>
                    {/* Hair */}
                    <rect x="5" y="0" width="6" height="3" fill="#1a1a1a"/>
                    {/* Face */}
                    <rect x="5" y="3" width="6" height="4" fill="#D4A574"/>
                    {/* Eyes - determined */}
                    <rect x="6" y="4" width="1" height="1" fill="#1a1a1a"/>
                    <rect x="9" y="4" width="1" height="1" fill="#1a1a1a"/>
                    {/* Body - white tunic */}
                    <rect x="4" y="7" width="8" height="5" fill="#F5F5F5"/>
                    <rect x="4" y="11" width="8" height="1" fill="#EAB308"/>
                    {/* Arms raised triumphantly */}
                    <rect x="1" y="5" width="2" height="4" fill="#F5F5F5"/>
                    <rect x="13" y="5" width="2" height="4" fill="#F5F5F5"/>
                    <rect x="0" y="3" width="2" height="2" fill="#D4A574"/>
                    <rect x="14" y="3" width="2" height="2" fill="#D4A574"/>
                    {/* Legs - RED pants */}
                    <rect x="5" y="12" width="2" height="6" fill="#DC2626"/>
                    <rect x="9" y="12" width="2" height="6" fill="#DC2626"/>
                    <rect x="4" y="18" width="3" height="2" fill="#8B4513"/>
                    <rect x="9" y="18" width="3" height="2" fill="#8B4513"/>
                    {/* Sword raised */}
                    <rect x="0" y="0" width="1" height="6" fill="#E5E7EB"/>
                    <rect x="-1" y="5" width="3" height="1" fill="#EAB308"/>
                </svg>
            </div>
        );
    }
    
    return (
        <div className={`relative ${className} ${fighting ? 'prince-fight' : ''} ${slashing ? 'prince-slash' : ''}`} 
             style={{ width: '32px', height: '40px', filter: 'drop-shadow(1px 1px 0 #000) drop-shadow(-1px -1px 0 #000)' }}>
            {/* Prince pixel art - white outfit, RED pants, dark hair */}
            <svg viewBox="0 0 16 20" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Hair */}
                <rect x="5" y="0" width="6" height="3" fill="#1a1a1a"/>
                {/* Face */}
                <rect x="5" y="3" width="6" height="4" fill="#D4A574"/>
                {/* Eyes */}
                <rect x="6" y="4" width="1" height="1" fill="#1a1a1a"/>
                <rect x="9" y="4" width="1" height="1" fill="#1a1a1a"/>
                {/* Body - white tunic */}
                <rect x="4" y="7" width="8" height="5" fill="#F5F5F5"/>
                <rect x="5" y="7" width="6" height="1" fill="#E5E5E5"/>
                {/* Belt */}
                <rect x="4" y="11" width="8" height="1" fill="#EAB308"/>
                {/* Arms */}
                <rect x="2" y="7" width="2" height="4" fill="#F5F5F5"/>
                <rect x="12" y="7" width="2" height="4" fill="#F5F5F5"/>
                {/* Hands */}
                <rect x="1" y="9" width="2" height="2" fill="#D4A574"/>
                <rect x="13" y="9" width="2" height="2" fill="#D4A574"/>
                {/* Legs - RED pants for visibility */}
                <rect x="5" y="12" width="2" height="6" fill="#DC2626"/>
                <rect x="9" y="12" width="2" height="6" fill="#DC2626"/>
                {/* Feet */}
                <rect x="4" y="18" width="3" height="2" fill="#8B4513"/>
                <rect x="9" y="18" width="3" height="2" fill="#8B4513"/>
                {/* Sword in hand - with dark outline */}
                <rect x="-1" y="4" width="3" height="1" fill="#1a1a1a"/>
                <rect x="0" y="4" width="1" height="8" fill="#E5E7EB"/>
                <rect x="0" y="3" width="1" height="1" fill="#FFFFFF"/>
                <rect x="-1" y="11" width="3" height="2" fill="#EAB308"/>
                <rect x="0" y="13" width="1" height="1" fill="#8B4513"/>
            </svg>
            {/* Throwing knife animation - direction based on guard position */}
            {throwingKnife && (
                <div 
                    className={`absolute top-4 knife-throw ${knifeDirection === 'left' ? 'knife-throw-left' : 'knife-throw-right'}`}
                    style={{ 
                        left: knifeDirection === 'left' ? '-10px' : '20px',
                    }}
                >
                    <svg 
                        width="16" 
                        height="8" 
                        viewBox="0 0 8 4" 
                        style={{ 
                            imageRendering: 'pixelated',
                            transform: knifeDirection === 'left' ? 'scaleX(-1)' : 'none'
                        }}
                    >
                        <rect x="0" y="1" width="5" height="2" fill="#C0C0C0"/>
                        <rect x="5" y="0" width="3" height="4" fill="#8B4513"/>
                    </svg>
                </div>
            )}
        </div>
    );
}

export function PixelWrench({ className = "" }) {
    return (
        <div className={`${className} wrench-container`} style={{ width: '48px', height: '48px', position: 'relative' }}>
            {/* Bolt (pivot point) - stays fixed */}
            <div className="absolute" style={{ 
                left: '6px', 
                top: '14px', 
                width: '12px', 
                height: '12px',
                zIndex: 10
            }}>
                <svg viewBox="0 0 8 8" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                    {/* Hex bolt head */}
                    <rect x="1" y="0" width="6" height="1" fill="#4B5563"/>
                    <rect x="0" y="1" width="8" height="6" fill="#6B7280"/>
                    <rect x="1" y="7" width="6" height="1" fill="#4B5563"/>
                    {/* Bolt center detail */}
                    <rect x="3" y="3" width="2" height="2" fill="#374151"/>
                    {/* Shine */}
                    <rect x="2" y="2" width="1" height="1" fill="#9CA3AF"/>
                </svg>
            </div>
            {/* Wrench - rotates around the bolt */}
            <div className="wrench-turn-around-bolt" style={{ 
                position: 'absolute',
                width: '48px',
                height: '48px',
                transformOrigin: '12px 20px'
            }}>
                <svg viewBox="0 0 24 24" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                    {/* Wrench head - open jaw wrapping around bolt position */}
                    {/* Upper jaw */}
                    <rect x="0" y="4" width="3" height="4" fill="#9CA3AF"/>
                    <rect x="3" y="6" width="4" height="4" fill="#6B7280"/>
                    {/* Lower jaw */}
                    <rect x="0" y="14" width="3" height="4" fill="#9CA3AF"/>
                    <rect x="3" y="12" width="4" height="4" fill="#6B7280"/>
                    {/* Inner jaw teeth */}
                    <rect x="1" y="6" width="2" height="2" fill="#4B5563"/>
                    <rect x="1" y="14" width="2" height="2" fill="#4B5563"/>
                    {/* Jaw gap for bolt */}
                    <rect x="0" y="8" width="2" height="1" fill="#374151"/>
                    <rect x="0" y="13" width="2" height="1" fill="#374151"/>
                    {/* Wrench shaft */}
                    <rect x="7" y="8" width="10" height="6" fill="#9CA3AF"/>
                    <rect x="7" y="11" width="10" height="3" fill="#6B7280"/>
                    {/* Shaft detail lines */}
                    <rect x="9" y="8" width="1" height="6" fill="#4B5563"/>
                    <rect x="12" y="8" width="1" height="6" fill="#4B5563"/>
                    {/* Handle grip */}
                    <rect x="17" y="6" width="7" height="10" fill="#4B5563"/>
                    <rect x="18" y="7" width="5" height="8" fill="#374151"/>
                    <rect x="19" y="8" width="3" height="6" fill="#1F2937"/>
                    {/* Handle end cap */}
                    <rect x="22" y="7" width="2" height="8" fill="#4B5563"/>
                    {/* Shine/highlight effects */}
                    <rect x="1" y="5" width="1" height="2" fill="#D1D5DB"/>
                    <rect x="8" y="8" width="2" height="1" fill="#E5E7EB"/>
                    <rect x="18" y="7" width="1" height="1" fill="#6B7280"/>
                </svg>
            </div>
        </div>
    );
}

export function PoweredUpSultan({ className = "" }) {
    return (
        <div className={`relative ${className} sultan-power-up`} 
             style={{ width: '56px', height: '72px' }}>
            {/* Powered up Evil Sultan with integrated lightning */}
            <svg viewBox="0 0 28 36" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Aura glow */}
                <rect x="4" y="4" width="20" height="28" fill="#8B0000" opacity="0.3"/>
                
                {/* Lightning bolts from hands */}
                <g className="lightning-flash">
                    {/* Left lightning */}
                    <rect x="0" y="22" width="2" height="3" fill="#FBBF24"/>
                    <rect x="1" y="25" width="2" height="2" fill="#EAB308"/>
                    <rect x="0" y="27" width="2" height="3" fill="#FBBF24"/>
                    <rect x="1" y="30" width="2" height="2" fill="#EAB308"/>
                    <rect x="0" y="32" width="2" height="2" fill="#FEF08A"/>
                    
                    {/* Right lightning */}
                    <rect x="26" y="22" width="2" height="3" fill="#FBBF24"/>
                    <rect x="25" y="25" width="2" height="2" fill="#EAB308"/>
                    <rect x="26" y="27" width="2" height="3" fill="#FBBF24"/>
                    <rect x="25" y="30" width="2" height="2" fill="#EAB308"/>
                    <rect x="26" y="32" width="2" height="2" fill="#FEF08A"/>
                </g>
                
                {/* Staff lightning */}
                <g className="lightning-flash" style={{ animationDelay: '0.2s' }}>
                    <rect x="2" y="6" width="2" height="2" fill="#FF0000"/>
                    <rect x="1" y="8" width="2" height="3" fill="#FBBF24"/>
                    <rect x="2" y="11" width="2" height="2" fill="#EAB308"/>
                </g>
                
                {/* Larger turban */}
                <rect x="8" y="2" width="12" height="6" fill="#2D0A4E"/>
                <rect x="9" y="3" width="10" height="4" fill="#4B0082"/>
                {/* Multiple jewels */}
                <rect x="12" y="3" width="4" height="3" fill="#EAB308"/>
                <rect x="13" y="2" width="2" height="1" fill="#DC2626"/>
                <rect x="10" y="4" width="2" height="2" fill="#DC2626"/>
                <rect x="16" y="4" width="2" height="2" fill="#DC2626"/>
                {/* Feathers */}
                <rect x="16" y="2" width="2" height="4" fill="#DC2626"/>
                <rect x="18" y="3" width="1" height="3" fill="#B91C1C"/>
                
                {/* Face - more sinister */}
                <rect x="10" y="8" width="8" height="6" fill="#8B7355"/>
                {/* Glowing evil eyes */}
                <rect x="11" y="9" width="2" height="3" fill="#FF0000"/>
                <rect x="15" y="9" width="2" height="3" fill="#FF0000"/>
                {/* Eye glow effect */}
                <rect x="10" y="9" width="1" height="3" fill="#FF0000" opacity="0.5"/>
                <rect x="17" y="9" width="1" height="3" fill="#FF0000" opacity="0.5"/>
                {/* Evil grin */}
                <rect x="11" y="12" width="6" height="1" fill="#1a1a1a"/>
                {/* Beard */}
                <rect x="11" y="13" width="6" height="4" fill="#1a1a1a"/>
                <rect x="12" y="16" width="4" height="2" fill="#1a1a1a"/>
                
                {/* Larger robe */}
                <rect x="6" y="14" width="16" height="14" fill="#2D0A4E"/>
                <rect x="8" y="15" width="12" height="3" fill="#4B0082"/>
                {/* Gold trim - more elaborate */}
                <rect x="6" y="14" width="16" height="2" fill="#EAB308"/>
                <rect x="12" y="16" width="4" height="10" fill="#EAB308"/>
                {/* Power crystals on robe */}
                <rect x="8" y="20" width="2" height="2" fill="#DC2626"/>
                <rect x="18" y="20" width="2" height="2" fill="#DC2626"/>
                
                {/* Arms raised with power */}
                <rect x="3" y="14" width="3" height="10" fill="#2D0A4E"/>
                <rect x="22" y="14" width="3" height="10" fill="#2D0A4E"/>
                {/* Glowing hands */}
                <rect x="2" y="20" width="3" height="3" fill="#FF6B6B"/>
                <rect x="23" y="20" width="3" height="3" fill="#FF6B6B"/>
                
                {/* Magic staff - larger and glowing */}
                <rect x="2" y="10" width="2" height="18" fill="#8B4513"/>
                <rect x="1" y="6" width="4" height="5" fill="#EAB308"/>
                {/* Staff gem - large and glowing */}
                <rect x="1" y="4" width="4" height="3" fill="#FF0000"/>
                
                {/* Feet */}
                <rect x="9" y="28" width="4" height="2" fill="#2D0A4E"/>
                <rect x="15" y="28" width="4" height="2" fill="#2D0A4E"/>
            </svg>
        </div>
    );
}

// Different guard variants with unique outfits
const guardVariants = [
    // Variant 0: Classic dark guard
    { armor: '#2D2D2D', accent: '#4A4A4A', sash: '#8B0000', helmet: '#4A4A4A', pants: '#1a1a1a' },
    // Variant 1: Blue palace guard
    { armor: '#1E3A5F', accent: '#2E5A8F', sash: '#EAB308', helmet: '#1E3A5F', pants: '#0F1F3F' },
    // Variant 2: Green forest guard
    { armor: '#1F4F3F', accent: '#2F6F5F', sash: '#8B4513', helmet: '#1F4F3F', pants: '#0F2F1F' },
    // Variant 3: Purple elite guard
    { armor: '#4B0082', accent: '#6B20A2', sash: '#FFD700', helmet: '#3B0062', pants: '#2B0052' },
    // Variant 4: Red captain
    { armor: '#8B0000', accent: '#AB2020', sash: '#000000', helmet: '#6B0000', pants: '#4B0000' },
    // Variant 5: Bronze veteran
    { armor: '#8B6914', accent: '#AB8934', sash: '#2D2D2D', helmet: '#7B5904', pants: '#5B4904' },
    // Variant 6: Silver knight
    { armor: '#5F5F6F', accent: '#7F7F8F', sash: '#1E3A5F', helmet: '#4F4F5F', pants: '#3F3F4F' },
    // Variant 7: Black shadow guard
    { armor: '#1a1a1a', accent: '#2a2a2a', sash: '#DC2626', helmet: '#0a0a0a', pants: '#000000' },
];

export function PixelGuard({ className = "", defeated = false, variant = 0 }) {
    const colors = guardVariants[variant % guardVariants.length];
    
    return (
        <div className={`relative ${className} ${defeated ? 'guard-defeat' : 'guard-shake'}`} 
             style={{ width: '32px', height: '40px' }}>
            {/* Guard pixel art - varied outfits */}
            <svg viewBox="0 0 16 20" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Helmet */}
                <rect x="4" y="0" width="8" height="4" fill={colors.helmet}/>
                <rect x="5" y="0" width="6" height="1" fill={colors.accent}/>
                {/* Helmet spike/plume based on variant */}
                {variant % 3 === 0 && <rect x="7" y="-1" width="2" height="2" fill={colors.sash}/>}
                {variant % 3 === 1 && <rect x="6" y="-1" width="4" height="1" fill={colors.accent}/>}
                {/* Face visible part */}
                <rect x="5" y="3" width="6" height="3" fill="#C4956A"/>
                {/* Eyes - menacing red */}
                <rect x="6" y="4" width="1" height="1" fill="#8B0000"/>
                <rect x="9" y="4" width="1" height="1" fill="#8B0000"/>
                {/* Body - armor */}
                <rect x="4" y="6" width="8" height="7" fill={colors.armor}/>
                <rect x="5" y="7" width="6" height="1" fill={colors.accent}/>
                {/* Chest detail */}
                <rect x="6" y="8" width="4" height="2" fill={colors.accent}/>
                {/* Sash/belt */}
                <rect x="4" y="10" width="8" height="1" fill={colors.sash}/>
                {/* Arms with armor */}
                <rect x="2" y="6" width="2" height="5" fill={colors.armor}/>
                <rect x="12" y="6" width="2" height="5" fill={colors.armor}/>
                {/* Shoulder pads */}
                <rect x="2" y="6" width="2" height="1" fill={colors.accent}/>
                <rect x="12" y="6" width="2" height="1" fill={colors.accent}/>
                {/* Hands */}
                <rect x="1" y="9" width="2" height="2" fill="#C4956A"/>
                <rect x="13" y="9" width="2" height="2" fill="#C4956A"/>
                {/* Legs */}
                <rect x="5" y="13" width="2" height="5" fill={colors.pants}/>
                <rect x="9" y="13" width="2" height="5" fill={colors.pants}/>
                {/* Feet */}
                <rect x="4" y="18" width="3" height="2" fill={colors.armor}/>
                <rect x="9" y="18" width="3" height="2" fill={colors.armor}/>
                {/* Scimitar */}
                <rect x="14" y="5" width="1" height="5" fill="#C0C0C0"/>
                <rect x="15" y="4" width="1" height="3" fill="#E5E7EB"/>
            </svg>
        </div>
    );
}

export function PixelSultan({ className = "", castingSpell = false }) {
    return (
        <div className={`relative ${className}`} 
             style={{ width: '40px', height: '48px' }}>
            {/* Evil Sultan/Jaffar pixel art */}
            <svg viewBox="0 0 20 24" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Turban */}
                <rect x="6" y="0" width="8" height="5" fill="#4B0082"/>
                <rect x="7" y="1" width="6" height="3" fill="#5B1092"/>
                {/* Jewel */}
                <rect x="9" y="1" width="2" height="2" fill="#EAB308"/>
                <rect x="9" y="0" width="2" height="1" fill="#DC2626"/>
                {/* Feather */}
                <rect x="12" y="0" width="1" height="3" fill="#DC2626"/>
                <rect x="13" y="1" width="1" height="2" fill="#B91C1C"/>
                {/* Face - sinister */}
                <rect x="7" y="5" width="6" height="5" fill="#8B7355"/>
                {/* Evil eyes - glowing when casting */}
                <rect x="8" y="6" width="1" height="2" fill={castingSpell ? "#FF0000" : "#8B0000"}/>
                <rect x="11" y="6" width="1" height="2" fill={castingSpell ? "#FF0000" : "#8B0000"}/>
                {/* Eyebrows - angry */}
                <rect x="8" y="5" width="2" height="1" fill="#1a1a1a"/>
                <rect x="10" y="5" width="2" height="1" fill="#1a1a1a"/>
                {/* Evil grin */}
                <rect x="8" y="8" width="4" height="1" fill="#1a1a1a"/>
                {/* Beard */}
                <rect x="8" y="9" width="4" height="3" fill="#1a1a1a"/>
                <rect x="9" y="11" width="2" height="2" fill="#1a1a1a"/>
                {/* Robe - purple/black */}
                <rect x="5" y="10" width="10" height="10" fill="#2D0A4E"/>
                <rect x="6" y="11" width="8" height="2" fill="#4B0082"/>
                {/* Gold trim */}
                <rect x="5" y="10" width="10" height="1" fill="#EAB308"/>
                <rect x="9" y="12" width="2" height="6" fill="#EAB308"/>
                {/* Arms raised for casting */}
                <rect x="3" y="10" width="2" height="7" fill="#2D0A4E"/>
                <rect x="15" y="10" width="2" height="7" fill="#2D0A4E"/>
                {/* Hands - one raised with staff */}
                <rect x="2" y="14" width="2" height="2" fill="#8B7355"/>
                <rect x="16" y="14" width="2" height="2" fill="#8B7355"/>
                {/* Magic staff raised */}
                <rect x="0" y="6" width="1" height="12" fill="#8B4513"/>
                <rect x="0" y="4" width="2" height="3" fill="#EAB308"/>
                {/* Staff gem - glowing */}
                <rect x="0" y="3" width="2" height="2" fill={castingSpell ? "#FF0000" : "#DC2626"}/>
                {castingSpell && <rect x="-1" y="2" width="4" height="4" fill="#FF0000" opacity="0.3"/>}
                {/* Feet */}
                <rect x="7" y="20" width="3" height="2" fill="#2D0A4E"/>
                <rect x="10" y="20" width="3" height="2" fill="#2D0A4E"/>
            </svg>
        </div>
    );
}

export function MagicSpell({ className = "" }) {
    return (
        <div className={`${className} spell-animation`} style={{ width: '24px', height: '32px' }}>
            <svg viewBox="0 0 12 16" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Lightning bolt */}
                <rect x="5" y="0" width="3" height="2" fill="#EAB308"/>
                <rect x="4" y="2" width="3" height="2" fill="#FBBF24"/>
                <rect x="5" y="4" width="4" height="2" fill="#EAB308"/>
                <rect x="6" y="6" width="3" height="2" fill="#FBBF24"/>
                <rect x="5" y="8" width="3" height="2" fill="#EAB308"/>
                <rect x="4" y="10" width="3" height="2" fill="#FBBF24"/>
                <rect x="5" y="12" width="2" height="2" fill="#EAB308"/>
                <rect x="5" y="14" width="1" height="2" fill="#FEF08A"/>
                {/* Glow effect */}
                <rect x="3" y="4" width="1" height="4" fill="#FEF08A" opacity="0.5"/>
                <rect x="8" y="6" width="1" height="4" fill="#FEF08A" opacity="0.5"/>
            </svg>
        </div>
    );
}

export function PixelPotion({ className = "" }) {
    return (
        <div className={`${className}`} style={{ width: '16px', height: '24px' }}>
            <svg viewBox="0 0 8 12" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Bottle neck */}
                <rect x="3" y="0" width="2" height="2" fill="#C4B5A0"/>
                {/* Cork */}
                <rect x="3" y="0" width="2" height="1" fill="#8B4513"/>
                {/* Bottle body */}
                <rect x="1" y="2" width="6" height="8" fill="#DC2626"/>
                <rect x="2" y="3" width="2" height="5" fill="#EF4444"/>
                {/* Shine */}
                <rect x="2" y="3" width="1" height="3" fill="#FCA5A5"/>
                {/* Bubbles */}
                <rect x="4" y="7" width="1" height="1" fill="#FCA5A5"/>
                <rect x="5" y="5" width="1" height="1" fill="#FCA5A5"/>
            </svg>
        </div>
    );
}

export function PixelSword({ className = "" }) {
    return (
        <div className={`${className}`} style={{ width: '24px', height: '48px' }}>
            <svg viewBox="0 0 6 12" className="w-full h-full" style={{ imageRendering: 'pixelated' }}>
                {/* Blade */}
                <rect x="2" y="0" width="2" height="8" fill="#E5E7EB"/>
                <rect x="3" y="0" width="1" height="7" fill="#F9FAFB"/>
                {/* Guard */}
                <rect x="0" y="7" width="6" height="1" fill="#EAB308"/>
                {/* Handle */}
                <rect x="2" y="8" width="2" height="3" fill="#8B4513"/>
                {/* Pommel */}
                <rect x="2" y="11" width="2" height="1" fill="#EAB308"/>
            </svg>
        </div>
    );
}

// Prince Portrait for flip card - challenging pose saying "A Duel?"
export function PixelPrincePortrait({ className = "", flipCardHint = "flip to reveal your new fav character" }) {
    return (
        <div className={`${className} flex flex-col items-center justify-center`} style={{ width: '100%', height: '100%' }}>
            {/* Speech bubble */}
            <div 
                className="relative mb-2 px-4 py-2 bg-card border-2 border-primary"
                style={{ fontFamily: "'Silkscreen', cursive" }}
            >
                <span className="text-primary text-sm uppercase tracking-wider">A Duel?</span>
                {/* Speech bubble tail */}
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-primary" />
            </div>
            
            {/* Prince character - larger, challenging pose with sword pointing forward */}
            <svg viewBox="0 0 32 48" className="w-32 h-48" style={{ imageRendering: 'pixelated' }}>
                {/* Hair */}
                <rect x="11" y="2" width="10" height="5" fill="#1a1a1a"/>
                <rect x="10" y="4" width="2" height="3" fill="#1a1a1a"/>
                {/* Face */}
                <rect x="11" y="7" width="10" height="7" fill="#D4A574"/>
                {/* Eyes - determined look */}
                <rect x="13" y="9" width="2" height="2" fill="#1a1a1a"/>
                <rect x="17" y="9" width="2" height="2" fill="#1a1a1a"/>
                {/* Eyebrows - confident */}
                <rect x="12" y="8" width="3" height="1" fill="#1a1a1a"/>
                <rect x="17" y="8" width="3" height="1" fill="#1a1a1a"/>
                {/* Confident smirk */}
                <rect x="14" y="12" width="4" height="1" fill="#8B5A2B"/>
                <rect x="15" y="11" width="1" height="1" fill="#8B5A2B"/>
                
                {/* Body - white tunic */}
                <rect x="9" y="14" width="14" height="10" fill="#F5F5F5"/>
                <rect x="10" y="15" width="12" height="2" fill="#E5E5E5"/>
                {/* Belt */}
                <rect x="9" y="22" width="14" height="2" fill="#EAB308"/>
                <rect x="14" y="22" width="4" height="2" fill="#D4A017"/>
                
                {/* Left arm pointing sword forward */}
                <rect x="3" y="14" width="6" height="4" fill="#F5F5F5"/>
                <rect x="1" y="15" width="4" height="3" fill="#F5F5F5"/>
                {/* Left hand */}
                <rect x="0" y="15" width="2" height="3" fill="#D4A574"/>
                
                {/* Right arm on hip */}
                <rect x="23" y="14" width="4" height="6" fill="#F5F5F5"/>
                <rect x="25" y="18" width="3" height="3" fill="#D4A574"/>
                
                {/* Sword pointing at viewer (extending left) */}
                <rect x="-12" y="15" width="14" height="2" fill="#E5E7EB"/>
                <rect x="-12" y="15" width="2" height="2" fill="#FFFFFF"/>
                <rect x="-14" y="14" width="2" height="4" fill="#F9FAFB"/>
                {/* Sword shine */}
                <rect x="-10" y="15" width="6" height="1" fill="#FFFFFF"/>
                {/* Guard */}
                <rect x="0" y="13" width="2" height="6" fill="#EAB308"/>
                
                {/* Legs - RED pants in fighting stance */}
                <rect x="10" y="24" width="5" height="12" fill="#DC2626"/>
                <rect x="17" y="24" width="5" height="10" fill="#DC2626"/>
                <rect x="19" y="32" width="4" height="4" fill="#DC2626"/>
                
                {/* Feet */}
                <rect x="8" y="36" width="6" height="4" fill="#8B4513"/>
                <rect x="19" y="34" width="6" height="4" fill="#8B4513"/>
                
                {/* Cape flowing behind */}
                <rect x="22" y="14" width="4" height="14" fill="#8B0000"/>
                <rect x="24" y="16" width="4" height="10" fill="#6B0000"/>
                <rect x="26" y="20" width="3" height="6" fill="#4B0000"/>
            </svg>
            
            {/* Click hint */}
            <p 
                className="mt-2 text-[10px] text-muted-foreground uppercase tracking-wider text-center px-2"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
                {flipCardHint}
            </p>
        </div>
    );
}
